import { Globe, MessageCircle, FileText, Settings } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { useColonyContext } from "@/hooks/useColonyContext";

export function BottomTabs() {
	const [mounted, setMounted] = useState(false);
	
	// Always call hooks at the top level
	const navigate = useNavigate();
	const location = useLocation();
	const { activeColonyId } = useColonyContext();
	
	// Set mounted after first render to ensure router context is ready
	useEffect(() => {
		setMounted(true);
	}, []);

	// Don't render until component is mounted and router is ready
	if (!mounted) {
		return null;
	}

	// Hide bottom tabs only on landing page
	if (location.pathname === "/") {
		return null;
	}

	const getKnowledgePath = () => {
		if (activeColonyId) {
			return `/knowledge/${activeColonyId}`;
		}
		return "/knowledge";
	};

	const getChatPath = () => {
		if (activeColonyId) {
			return `/chat/${activeColonyId}`;
		}
		return "/chat";
	};

	const tabs = [
		{ id: "controlroom", icon: Globe, label: "Control Room", path: "/control-room" },
		{ id: "chat", icon: MessageCircle, label: "Chat", path: getChatPath() },
		{ id: "knowledge", icon: FileText, label: "Knowledge", path: getKnowledgePath() },
		{ id: "settings", icon: Settings, label: "Settings", path: "/settings" },
	];

	const getActiveTab = () => {
		const path = location.pathname;
		if (path.startsWith("/chat")) return "chat";
		if (path.startsWith("/knowledge")) return "knowledge"; 
		if (path.startsWith("/settings")) return "settings";
		if (path.startsWith("/control-room")) return "controlroom";
		return "controlroom";
	};

	const activeTab = getActiveTab();

	return (
		<nav
			className="fixed bottom-0 left-0 right-0 z-40 flex items-center justify-around border-t border-ios-separator bg-[hsl(var(--nav-background))] whitespace-nowrap"
			style={{ height: `calc(var(--tabbar-h) + var(--safe-bottom) + var(--tabbar-gap))`, paddingBottom: `calc(var(--safe-bottom) + var(--tabbar-gap))` }}
		>
			<div className="flex items-center justify-around py-2 w-full">
				{tabs.map((tab) => {
					const IconComponent = tab.icon;
					const isActive = activeTab === tab.id;
					
					return (
						<button
							key={tab.id}
							onClick={() => {
								console.log(`[BottomTabs] Navigating to: ${tab.path}`);
								navigate(tab.path);
							}}
							className={cn(
								"flex flex-col items-center justify-center py-2 px-4 min-w-0 flex-1",
								"transition-all duration-200 active:scale-95 min-h-[44px]"
							)}
						>
							<IconComponent 
								size={24} 
								className={cn(
									"transition-colors duration-200",
									isActive ? "text-nav-active" : "text-nav-inactive hover:text-nav-active/70"
								)} 
							/>
							<span className={cn(
								"text-xs leading-tight whitespace-nowrap mt-1 font-medium",
								isActive ? "text-nav-active" : "text-nav-inactive"
							)}>
								{tab.label}
							</span>
						</button>
					);
				})}
			</div>
		</nav>
	);
}


